/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface TradePlayerIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * TradePlayerIcon component - indicates player trade/swap functionality
 * Displays bidirectional arrows for trading players between teams.
 * Follows ts-components icon standards (size, color, className props).
 */
const TradePlayerIcon = ({
  size = 24,
  color = colors.PRIMARY,
  className,
}: TradePlayerIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M6.99 11.5L3 15.5L6.99 19.5V16.5H14V14.5H6.99V11.5ZM21 9.5L17.01 5.5V8.5H10V10.5H17.01V13.5L21 9.5Z'
        fill={color}
      />
    </svg>
  )
}

export default TradePlayerIcon
